import React, { useState, useEffect, useContext } from 'react';
import '../App.css';
import axios from 'axios';
import Sidebar from '../componenteExtra/SidebarseniorGET';
import { GrupoContext } from '../GrupoContext';
import Modal from 'react-modal';
import { Toaster } from 'react-hot-toast';
import * as XLSX from 'xlsx';
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement('#root');

const VerLiderSubrogante2 = () => {
    const { grupo, setGrupo } = useContext(GrupoContext);
    const [liderList, setLiderList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedGrupo, setSelectedGrupo] = useState(null);
    const [undocumentedActivities, setUndocumentedActivities] = useState([]);
    const [undocumentedModalIsOpen, setUndocumentedModalIsOpen] = useState(false);
    const [unassignedActivities, setUnassignedActivities] = useState([]);
    const [unassignedModalIsOpen, setUnassignedModalIsOpen] = useState(false);
    const [assignedActivities, setAssignedActivities] = useState([]);
    const [assignedModalIsOpen, setAssignedModalIsOpen] = useState(false);
    const [approvalPendingActivities, setApprovalPendingActivities] = useState([]);
    const [approvalPendingModalIsOpen, setApprovalPendingModalIsOpen] = useState(false);
    const [realCounts, setRealCounts] = useState({});
    const [loadingCounts, setLoadingCounts] = useState(true);

    const token = localStorage.getItem("access_token");

    // === CARGAR LÍDERES Y CONTEOS REALES AL INICIO ===
    useEffect(() => {
        const savedGrupo = localStorage.getItem('grupo');
        if (savedGrupo) setGrupo(savedGrupo);

        axios.get(`${process.env.REACT_APP_BACKEND_URL}/update_all_activity_counts`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => fetchLideres())
        .catch(error => console.error('Error al actualizar conteos: ', error));
    }, [setGrupo]);

    const fetchLideres = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_all_lideres`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then(response => {
            setLiderList(response.data);

            // Inicializar con valores del backend (fallback)
            const initialCounts = {};
            response.data.forEach(lider => {
                initialCounts[lider.numero_grupo] = {
                    sin_documentar: lider.actividades_sin_documentar || 0,
                    sin_asignar: lider.actividades_sin_asignar || 0,
                    asignadas: lider.actividades_asignadas || 0,
                    espera_aprobacion: lider.espera_aprobacion || 0,
                };
            });
            setRealCounts(initialCounts);
            setLoadingCounts(true);
            loadAllRealCounts(response.data);
        })
        .catch(error => {
            console.error('Error fetching líderes: ', error);
            setLoadingCounts(false);
        });
    };

    // === PRECARGAR TODOS LOS CONTEOS REALES ===
    const loadAllRealCounts = async (lideres) => {
        if (!lideres || lideres.length === 0) {
            setLoadingCounts(false);
            return;
        }

        const endpoints = [
            { key: 'sin_documentar', url: g => `/waiting_for_documentation_for_number_group/${g}` },
            { key: 'sin_asignar', url: g => `/asignar_staff/${g}` },
            { key: 'asignadas', url: g => `/assigned_requests/${g}` },
            { key: 'espera_aprobacion', url: g => `/activities_pending_approval/${g}` },
        ];

        const promises = [];
        lideres.forEach(lider => {
            endpoints.forEach(ep => {
                promises.push(
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}${ep.url(lider.numero_grupo)}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then(res => ({ grupo: lider.numero_grupo, key: ep.key, count: (res.data || []).length }))
                    .catch(() => ({ grupo: lider.numero_grupo, key: ep.key, count: 0 }))
                );
            });
        });

        const results = await Promise.allSettled(promises);
        const updated = { ...realCounts };

        results.forEach(r => {
            if (r.status === 'fulfilled') {
                const { grupo, key, count } = r.value;
                if (!updated[grupo]) updated[grupo] = {};
                updated[grupo][key] = count;
            }
        });

        setRealCounts(updated);
        setLoadingCounts(false);
    };

    // === FILTRO DE LÍDERES ===
    const filteredLideres = liderList.filter(lider =>
        lider.nombre_lider.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // === OBTENER CONTEO REAL (o 0 si no existe) ===
    const getCount = (grupo, field) => realCounts[grupo]?.[field] ?? 0;

    // === EXPORTAR A EXCEL ===
    const exportToExcel = (data, prefix) => {
        const today = new Date();
        const formattedDate = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getFullYear()}`;
        const fileName = `${prefix}_${formattedDate}.xlsx`;

        const filteredData = data.map(item => ({
            'Código de Proyecto': item.codigo_proyecto,
            'Razón Social': item.razon_social,
            'Filial': item.filial,
            'Socio de auditoría': item.encargado_auditoria,
            'Solicitante': item.nombre_solicitante,
            'Rubro GET': item.rubro_get,
            'Nombre Actividad GET': item.nombre_actividad_get,
            'Fecha de Entrega de Información': item.fecha_entrega_informacion || '',
            'Fecha de Inicio': item.fecha_de_inicio || '',
            'Fecha de Término': item.fecha_de_termino || '',
            'Documentación': item.enlace_comentario || '',
            'Staff Asignado': item.staff_asignado || '',
            'Fecha Inicio Trabajo Staff': item.fecha_inicio_trabajo_staff || '',
            'Horas Estándar': item.horas_estandar || '',
            'Estado Staff': item.estados_staff || ''
        }));

        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Data");
        XLSX.writeFile(wb, fileName);
    };

    // === MODALES CON ACTUALIZACIÓN DE CONTEO ===
    const openUndocumentedModal = (numeroGrupo) => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/waiting_for_documentation_for_number_group/${numeroGrupo}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then(response => {
            const data = response.data || [];
            setUndocumentedActivities(data);
            setSelectedGrupo(numeroGrupo);
            setUndocumentedModalIsOpen(true);
            setRealCounts(prev => ({ ...prev, [numeroGrupo]: { ...prev[numeroGrupo], sin_documentar: data.length } }));
        })
        .catch(() => {
            setUndocumentedActivities([]);
            setRealCounts(prev => ({ ...prev, [numeroGrupo]: { ...prev[numeroGrupo], sin_documentar: 0 } }));
        });
    };

    const openUnassignedModal = (numeroGrupo) => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/asignar_staff/${numeroGrupo}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then(response => {
            const data = response.data || [];
            setUnassignedActivities(data);
            setSelectedGrupo(numeroGrupo);
            setUnassignedModalIsOpen(true);
            setRealCounts(prev => ({ ...prev, [numeroGrupo]: { ...prev[numeroGrupo], sin_asignar: data.length } }));
        })
        .catch(() => {
            setUnassignedActivities([]);
            setRealCounts(prev => ({ ...prev, [numeroGrupo]: { ...prev[numeroGrupo], sin_asignar: 0 } }));
        });
    };

    const openAssignedModal = (numeroGrupo) => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/assigned_requests/${numeroGrupo}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then(response => {
            const data = response.data || [];
            setAssignedActivities(data);
            setSelectedGrupo(numeroGrupo);
            setAssignedModalIsOpen(true);
            setRealCounts(prev => ({ ...prev, [numeroGrupo]: { ...prev[numeroGrupo], asignadas: data.length } }));
        })
        .catch(() => {
            setAssignedActivities([]);
            setRealCounts(prev => ({ ...prev, [numeroGrupo]: { ...prev[numeroGrupo], asignadas: 0 } }));
        });
    };

    const openApprovalPendingModal = (numeroGrupo) => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/activities_pending_approval/${numeroGrupo}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then(response => {
            const data = response.data || [];
            setApprovalPendingActivities(data);
            setSelectedGrupo(numeroGrupo);
            setApprovalPendingModalIsOpen(true);
            setRealCounts(prev => ({ ...prev, [numeroGrupo]: { ...prev[numeroGrupo], espera_aprobacion: data.length } }));
        })
        .catch(() => {
            setApprovalPendingActivities([]);
            setRealCounts(prev => ({ ...prev, [numeroGrupo]: { ...prev[numeroGrupo], espera_aprobacion: 0 } }));
        });
    };

    const closeModal = (setter) => () => setter(false);

    // === INDICADOR DE RIESGO ===
    const getRiskIndicatorColor = (fechaDoc, fechaTermino) => {
        const today = new Date();
        const endDate = new Date(fechaTermino);
        const diffDays = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
        if (diffDays >= 5) return 'green';
        if (diffDays > 3) return 'yellow';
        return 'red';
    };

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Ver todos los líderes</h1>

                    <div className="filter-section">
                        <label htmlFor="searchTerm">Buscar por nombre del Líder: </label>
                        <input
                            type="text"
                            id="searchTerm"
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                        />
                    </div>

                    {loadingCounts ? (
                        <div style={{ textAlign: 'center', padding: '30px', fontSize: '18px', color: '#181818ff' }}>
                            Cargando datos...
                        </div>
                    ) : (
                        <div className="activities-table-container">
                            <table className="activities-table">
                                <thead>
                                    <tr>
                                        <th>Número de Grupo</th>
                                        <th>Nombre del Líder</th>
                                        <th>Nombre Subrogante</th>
                                        <th>Cantidad de staff</th>
                                        <th>Actividades en espera</th>
                                        <th>Actividades sin asignar</th>
                                        <th>Actividades asignadas</th>
                                        <th>En espera de aprobación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredLideres.map((lider, index) => (
                                        <tr key={index}>
                                            <td>{lider.numero_grupo}</td>
                                            <td>{lider.nombre_lider}</td>
                                            <td>{lider.nombre_subrogante || '-'}</td>
                                            <td>{lider.cantidad_staff}</td>

                                            <td>
                                                {getCount(lider.numero_grupo, 'sin_documentar')}
                                                <button onClick={() => openUndocumentedModal(lider.numero_grupo)} style={{ marginLeft: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>
                                                    Ver
                                                </button>
                                            </td>

                                            <td>
                                                {getCount(lider.numero_grupo, 'sin_asignar')}
                                                <button onClick={() => openUnassignedModal(lider.numero_grupo)} style={{ marginLeft: '10px', backgroundColor: '#6f42c1', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>
                                                    Ver
                                                </button>
                                            </td>

                                            <td>
                                                {getCount(lider.numero_grupo, 'asignadas')}
                                                <button onClick={() => openAssignedModal(lider.numero_grupo)} style={{ marginLeft: '10px', backgroundColor: '#28a745', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>
                                                    Ver
                                                </button>
                                            </td>

                                            <td>
                                                {getCount(lider.numero_grupo, 'espera_aprobacion')}
                                                <button onClick={() => openApprovalPendingModal(lider.numero_grupo)} style={{ marginLeft: '10px', backgroundColor: '#ffc107', color: 'black', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>
                                                    Ver
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* === MODALES === */}
                    <Modal isOpen={undocumentedModalIsOpen} onRequestClose={closeModal(setUndocumentedModalIsOpen)} contentLabel="Sin Documentar">
                        <h2>Actividades sin documentar del grupo {selectedGrupo}</h2>
                        <button onClick={() => exportToExcel(undocumentedActivities, `SinDocumentar_Grupo${selectedGrupo}`)} className="green-button">Descargar Excel</button>
                        <button onClick={closeModal(setUndocumentedModalIsOpen)} className="red-button">Cerrar</button>
                        <div className="activities-table-container">
                            <table className="activities-table">
                                <thead>
                                    <tr>
                                        <th>Código Proyecto</th>
                                        <th>Razón Social</th>
                                        <th>Filial</th>
                                        <th>Socio de auditoría</th>
                                        <th>Nombre solicitante</th>
                                        <th>Rubro GET</th>
                                        <th>Nombre Actividad GET</th>
                                        <th>Fecha de Entrega</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {undocumentedActivities.map((a, i) => (
                                        <tr key={i}>
                                            <td>{a.codigo_proyecto}</td>
                                            <td>{a.razon_social}</td>
                                            <td>{a.filial}</td>
                                            <td>{a.encargado_auditoria}</td>
                                            <td>{a.nombre_solicitante}</td>
                                            <td>{a.rubro_get}</td>
                                            <td>{a.nombre_actividad_get}</td>
                                            <td>{a.fecha_entrega_informacion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal>

                    <Modal isOpen={unassignedModalIsOpen} onRequestClose={closeModal(setUnassignedModalIsOpen)} contentLabel="Sin Asignar">
                        <h2>Actividades sin asignar del grupo {selectedGrupo}</h2>
                        <button onClick={() => exportToExcel(unassignedActivities, `SinAsignar_Grupo${selectedGrupo}`)} className="green-button">Descargar Excel</button>
                        <button onClick={closeModal(setUnassignedModalIsOpen)} className="red-button">Cerrar</button>
                        <div className="activities-table-container">
                            <table className="activities-table">
                                <thead>
                                    <tr>
                                        <th>Código Proyecto</th>
                                        <th>Razón Social</th>
                                        <th>Filial</th>
                                        <th>Socio de auditoría</th>
                                        <th>Nombre solicitante</th>
                                        <th>Rubro GET</th>
                                        <th>Nombre Actividad GET</th>
                                        <th>Enlace Comentario</th>
                                        <th>Fecha de Entrega de Información</th>
                                        <th>Fecha de Documentación</th>
                                        <th>Fecha de Término de la Actividad</th>
                                        <th>Riesgo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {unassignedActivities.map((a, i) => (
                                        <tr key={i}>
                                            <td>{a.codigo_proyecto}</td>
                                            <td>{a.razon_social}</td>
                                            <td>{a.filial}</td>
                                            <td>{a.encargado_auditoria}</td>
                                            <td>{a.nombre_solicitante}</td>
                                            <td>{a.rubro_get}</td>
                                            <td>{a.nombre_actividad_get}</td>
                                            <td>{a.enlace_comentario}</td>
                                            <td>{a.fecha_entrega_informacion}</td>
                                            <td>{a.fecha_documentacion_actividad}</td>
                                            <td>{a.fecha_termino_senior_actividad}</td>
                                            <td><div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: getRiskIndicatorColor(a.fecha_documentacion_actividad, a.fecha_termino_senior_actividad) }} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal>

                    <Modal isOpen={assignedModalIsOpen} onRequestClose={closeModal(setAssignedModalIsOpen)} contentLabel="Asignadas">
                        <h2>Actividades asignadas del grupo {selectedGrupo}</h2>
                        <button onClick={() => exportToExcel(assignedActivities, `Asignadas_Grupo${selectedGrupo}`)} className="green-button">Descargar Excel</button>
                        <button onClick={closeModal(setAssignedModalIsOpen)} className="red-button">Cerrar</button>
                        <div className="activities-table-container">
                            <table className="activities-table">
                                <thead>
                                    <tr>
                                        <th>Código Proyecto</th>
                                        <th>Razón Social</th>
                                        <th>Filial</th>
                                        <th>Socio de auditoría</th>
                                        <th>Nombre solicitante</th>
                                        <th>Rubro GET</th>
                                        <th>Nombre Actividad GET</th>
                                        <th>Fecha de Entrega de Información</th>
                                        <th>Fecha de Inicio</th>
                                        <th>Fecha de Término</th>
                                        <th>Documentación</th>
                                        <th>Staff Asignado</th>
                                        <th>Fecha Inicio Trabajo Staff</th>
                                        <th>Horas Estándar</th>
                                        <th>Estado Staff</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {assignedActivities.map((a, i) => (
                                        <tr key={i}>
                                            <td>{a.codigo_proyecto}</td>
                                            <td>{a.razon_social}</td>
                                            <td>{a.filial}</td>
                                            <td>{a.encargado_auditoria}</td>
                                            <td>{a.nombre_solicitante}</td>
                                            <td>{a.rubro_get}</td>
                                            <td>{a.nombre_actividad_get}</td>
                                            <td>{a.fecha_entrega_informacion}</td>
                                            <td>{a.fecha_de_inicio || ''}</td>
                                            <td>{a.fecha_de_termino || ''}</td>
                                            <td>
                                                {a.enlace_comentario ? (
                                                    <a href={a.enlace_comentario} target="_blank" rel="noopener noreferrer" style={{ color: "#0066cc", textDecoration: "underline" }}>
                                                        Ver Documentación
                                                    </a>
                                                ) : "-"}
                                            </td>
                                            <td>{a.staff_asignado || ''}</td>
                                            <td>{a.fecha_inicio_trabajo_staff}</td>
                                            <td>{a.horas_estandar || ''}</td>
                                            <td>{a.estados_staff || ''}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal>

                    <Modal isOpen={approvalPendingModalIsOpen} onRequestClose={closeModal(setApprovalPendingModalIsOpen)} contentLabel="Pendientes Aprobación">
                        <h2>En espera de aprobación del grupo {selectedGrupo}</h2>
                        <button onClick={() => exportToExcel(approvalPendingActivities, `Aprobacion_Grupo${selectedGrupo}`)} className="green-button">Descargar Excel</button>
                        <button onClick={closeModal(setApprovalPendingModalIsOpen)} className="red-button">Cerrar</button>
                        <div className="activities-table-container">
                            <table className="activities-table">
                                <thead>
                                    <tr>
                                        <th>Código Proyecto</th>
                                        <th>Razón Social</th>
                                        <th>Filial</th>
                                        <th>Socio de auditoría</th>
                                        <th>Rubro GET</th>
                                        <th>Nombre Actividad GET</th>
                                        <th>Enlace Comentario</th>
                                        <th>Staff Asignado</th>
                                        <th>Fecha de Inicio - staff</th>
                                        <th>Fecha de Término - staff</th>
                                        <th>Horas Estándar</th>
                                        <th>Fecha de Término de la Actividad</th>
                                        <th>Riesgo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {approvalPendingActivities.map((a, i) => (
                                        <tr key={i}>
                                            <td>{a.codigo_proyecto}</td>
                                            <td>{a.razon_social}</td>
                                            <td>{a.filial}</td>
                                            <td>{a.encargado_auditoria}</td>
                                            <td>{a.rubro_get}</td>
                                            <td>{a.nombre_actividad_get}</td>
                                            <td>{a.enlace_comentario}</td>
                                            <td>{a.staff_asignado}</td>
                                            <td>{a.fecha_de_inicio}</td>
                                            <td>{a.fecha_de_termino}</td>
                                            <td>{a.horas_estandar}</td>
                                            <td>{a.fecha_termino_senior_actividad}</td>
                                            <td><div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: getRiskIndicatorColor(a.fecha_documentacion_actividad, a.fecha_termino_senior_actividad) }} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal>

                </div>
            </div>
            <Toaster />
        </div>
    );
};

export default VerLiderSubrogante2;